import { z } from "zod";
import { BaseResponseSchema } from "../../common/response/BaseResponseSchema";
// import { PropertyBankSchema } from "./ShowBankResponse";
import { GroupSchema } from "../../group/response/IndexGroupResponse";
import { PropertySchema as BaseSchema } from "./PropertyBaseSchema";

// const PivotSchema = z.object({
//     property_id: z.string().uuid(),
//     user_id: z.string().uuid(),
//     is_active: z.number(),
//     created_at: z.string().datetime(),
//     updated_at: z.string().datetime(),
// });

// const UserSchema = z.object({
//     id: z.string().uuid(),
//     name: z.string(),
//     email: z.string().email(),
//     email_verified_at: z.string().datetime().nullable(),
//     created_at: z.string().datetime(),
//     updated_at: z.string().datetime(),
//     channex_user_api_key: z.string().nullable(),
//     username: z.string().nullable(),
//     phone: z.string(),
//     pivot: PivotSchema,
// });

// const BankSchema = PropertyBankSchema;

// export const PropertySchema = z.object({
//     id: z.string().uuid(),
//     channex_id: z.string().uuid(),
//     name: z.string(),
//     accommodation_type: z.number(),
//     preferred_currency: z.string(),
//     time_zone: z.string(),
//     primary_email: z.string().email(),
//     cc_emails: z.array(z.string().email()).nullable(),
//     accounting_email: z.string().email().nullable(),
//     mobile_number_country_code: z.nullable(z.string()),
//     mobile_number: z.nullable(z.string()),
//     enable_cvv: z.coerce.number(),
//     primary_phone_country_code: z.string().nullable(),
//     primary_phone: z.string().nullable(),
//     website: z.string().url().nullable(),
//     country: z.string().nullable(),
//     state: z.string().nullable(),
//     city: z.string().nullable(),
//     street_address: z.string().nullable(),
//     postal_code: z.string().nullable(),
//     prefix_booking_number: z.string().nullable(),
//     hotel_tax_number: z.string().nullable(),
//     latitude: z.string().nullable(),
//     longitude: z.string().nullable(),
//     description: z.string().nullable(),
//     facebook_link: z.string().url().nullable(),
//     instagram_link: z.string().url().nullable(),
//     youtube_link: z.string().url().nullable(),
//     tiktok_link: z.string().url().nullable(),
//     logo: z.string().nullable(),
//     cover_image: z.string().nullable(),
//     created_at: z.string().datetime(),
//     updated_at: z.string().datetime(),
//     is_full_sync: z.boolean(),
//     property_type: z.string(),
//     settings: z.any().nullable(),
//     logo_url: z.string().nullable(),
//     users: z.array(UserSchema).optional(),
//     banks: z.array(BankSchema).optional(),
//     billing_type: z.string().nullable(),
// });

export const PropertySchema = BaseSchema;

export const PropertyWithGroupsSchema = PropertySchema.extend({
    groups: z.lazy(() => z.array(GroupSchema).optional()),
});

export const PropertyResponseSchema = BaseResponseSchema.extend({
    data: PropertySchema,
});

export type PropertyResponseType = z.infer<typeof PropertyResponseSchema>;
